import React from "react";
import {
  DisplayApps
} from "../../_metronic/_partials";

export function DApps(props) {
  return <DisplayApps {...props} />;
}
